import axios from 'axios'

var qs = require('qs');
var root=window.API_ROOT



//获取列表数据
export const getListData = (params) => {
  return axios.post(root+'/set/employee/list', qs.stringify(params))
}

//通讯录 获取列表数据
export const getTXLList = (params) => {
  return axios.post(root+'/set/employee/list4TXL', qs.stringify(params))
}

//获取某一行的明细数据
export const getDetail = (params) => {
  return axios.get(root+'/set/employee/detail', {params:params})
}

//保存某一行的数据
export const saveData = (params) => {

  if (params.uguid) {//修改
    return axios.post(root+'/set/employee/update', qs.stringify(params))
    // return axios.post(root+'/set/employee/update', params,{headers:{"Content-Type":"application/json"}})

  } else {//添加
    return axios.post(root+'/set/employee/save', qs.stringify(params))
  }
}

export const  updateSelf= (params) => {
    return axios.post(root+'/set/employee/updateSelf', qs.stringify(params))
}


export const  listByrolename= (params) => {
  return axios.post(root+'/set/employee/listByrolename', qs.stringify(params))
}

export const  updateMachineCode= (params) => {
  return axios.post(root+'/set/employee/updateMachineCode', qs.stringify(params))
}

//获取下拉框、单选按钮的绑定数据
export const getControlData = () => {
  return axios.post(root+'/set/employee/getcontroldata')
}

//获取人员树
export const getEmployeeTree =(params) => {
  return axios.post(root+'/set/employee/tree',qs.stringify(params))
}
//获取人员树
export const ghcode =(params) => {
  return axios.post(root+'/set/employee/ghcode',qs.stringify(params))
}





// WEBPACK FOOTER //
// ./src/api/set/employee.js